import { VoiceCallModel } from './model.js';
export var VoiceCallLanguage;
(function (VoiceCallLanguage) {
    VoiceCallLanguage["Bulgarian"] = "bg";
    VoiceCallLanguage["Chinese"] = "zh";
    VoiceCallLanguage["Czech"] = "cs";
    VoiceCallLanguage["Danish"] = "da";
    VoiceCallLanguage["Dutch"] = "nl";
    VoiceCallLanguage["English"] = "en";
    VoiceCallLanguage["Finnish"] = "fi";
    VoiceCallLanguage["French"] = "fr";
    VoiceCallLanguage["German"] = "de";
    VoiceCallLanguage["Hindi"] = "hi";
    VoiceCallLanguage["Hungarian"] = "hu";
    VoiceCallLanguage["Indonesian"] = "id";
    VoiceCallLanguage["Italian"] = "it";
    VoiceCallLanguage["Japanese"] = "ja";
    VoiceCallLanguage["Korean"] = "ko";
    VoiceCallLanguage["Malay"] = "ms";
    VoiceCallLanguage["Multilingual"] = "multi";
    VoiceCallLanguage["Polish"] = "pl";
    VoiceCallLanguage["Portuguese"] = "pt";
    VoiceCallLanguage["Romanian"] = "ro";
    VoiceCallLanguage["Russian"] = "ru";
    VoiceCallLanguage["Slovak"] = "sk";
    VoiceCallLanguage["Spanish"] = "es";
    VoiceCallLanguage["Swedish"] = "sv";
    VoiceCallLanguage["Tamil"] = "ta";
    VoiceCallLanguage["Turkish"] = "tr";
    VoiceCallLanguage["Ukrainian"] = "uk";
    VoiceCallLanguage["Vietnamese"] = "vi";
})(VoiceCallLanguage || (VoiceCallLanguage = {}));
/**
 * Voice provider identifiers used by Vapi.ai.
 * Values must match Vapi's API requirements exactly (lowercase format).
 * @see https://docs.vapi.ai/api-reference/assistants/create-assistant#request.body.voice.provider
 */
export var VoiceProvider;
(function (VoiceProvider) {
    VoiceProvider["ElevenLabs"] = "11labs";
    VoiceProvider["OpenAi"] = "openai";
    VoiceProvider["Cartesia"] = "cartesia";
})(VoiceProvider || (VoiceProvider = {}));
/**
 * ElevenLabs voice persona identifiers.
 * Compatible with ElevenLabs voice provider only.
 * @see https://elevenlabs.io/docs/voices/premade-voices
 * @see https://dashboard.vapi.ai/library/voice
 */
export var ElevenLabsVoicePersona;
(function (ElevenLabsVoicePersona) {
    ElevenLabsVoicePersona["Alice"] = "Xb7hH8MSUJpSbSDYk0k2";
    ElevenLabsVoicePersona["Arabella"] = "Z3R5wn05IrDiVCyEkUrK";
    ElevenLabsVoicePersona["Arnold"] = "VR6AewLTigWG4xSOukaG";
    ElevenLabsVoicePersona["Bill"] = "pqHfZKP75CvOlQylNhV4";
    ElevenLabsVoicePersona["Brian"] = "nPczCjzI2devNBz1zQrb";
    ElevenLabsVoicePersona["Carolina"] = "UOIqAnmS11Reiei1Ytkc";
    ElevenLabsVoicePersona["Charlie"] = "IKne3meq5aSn9XLyUdCD";
    ElevenLabsVoicePersona["Dakota"] = "P7x743VjyZEOihNNygQ9";
    ElevenLabsVoicePersona["Daniel"] = "onwK4e9ZLuTAKqWW03F9";
    ElevenLabsVoicePersona["Dorothy"] = "ThT5KcBeYPX3keUQqHPh";
    ElevenLabsVoicePersona["Eduardo"] = "W6Z2FAa578IKOGSVo2sA";
    ElevenLabsVoicePersona["Eric"] = "cjVigY5qzO86Huf0OWal";
    ElevenLabsVoicePersona["Gabriela"] = "hHjbwzYZW17oh0p05AKv";
    ElevenLabsVoicePersona["Javier"] = "CAEve7xpu0AvVWiKm2px";
    ElevenLabsVoicePersona["Jessa"] = "yj30vwTGJxSHezdAGsv9";
    ElevenLabsVoicePersona["Jessica"] = "cgSgspJ2msm6clMCkdW9";
    ElevenLabsVoicePersona["Josh"] = "TxGEqnHWrfWFTfGW9XjX";
    ElevenLabsVoicePersona["Kelli"] = "vvRU52fIIRzylmIUcoKl";
    ElevenLabsVoicePersona["Liam"] = "TX3LPaxmHKxFdv7VOQHJ";
    ElevenLabsVoicePersona["Maribeth"] = "JEAgwU0JZFGxl2KjC3if";
    ElevenLabsVoicePersona["Matthew"] = "Yko7PKHZNXotIFUBG7I9";
    ElevenLabsVoicePersona["Nicole"] = "piTKgcLEGmPE4e6mEKli";
    ElevenLabsVoicePersona["Paul"] = "5Q0t7uMcjvnagumLfvZi";
    ElevenLabsVoicePersona["Rachel"] = "21m00Tcm4TlvDq8ikWAM";
    ElevenLabsVoicePersona["Rhett"] = "D4xQvkd2SmpDZJ8sEwvA";
    ElevenLabsVoicePersona["Sarah"] = "sarah";
    ElevenLabsVoicePersona["Serena"] = "pMsXgVXv3BLzUgSXRplE";
})(ElevenLabsVoicePersona || (ElevenLabsVoicePersona = {}));
/**
 * OpenAI standard voice persona identifiers.
 * Compatible with all OpenAI models (both realtime and non-realtime).
 * @see https://platform.openai.com/docs/guides/realtime-voice
 */
export var OpenAiStandardVoicePersona;
(function (OpenAiStandardVoicePersona) {
    OpenAiStandardVoicePersona["Alloy"] = "alloy";
    OpenAiStandardVoicePersona["Echo"] = "echo";
    OpenAiStandardVoicePersona["Shimmer"] = "shimmer";
})(OpenAiStandardVoicePersona || (OpenAiStandardVoicePersona = {}));
/**
 * OpenAI realtime-exclusive voice persona identifiers.
 * Only compatible with OpenAI realtime models (gpt-4o-realtime, gpt-4o-mini-realtime, etc).
 * @see https://platform.openai.com/docs/guides/realtime-voice
 */
export var OpenAiRealtimeVoicePersona;
(function (OpenAiRealtimeVoicePersona) {
    OpenAiRealtimeVoicePersona["Marin"] = "marin";
    OpenAiRealtimeVoicePersona["Cedar"] = "cedar";
})(OpenAiRealtimeVoicePersona || (OpenAiRealtimeVoicePersona = {}));
/**
 * Cartesia voice persona identifiers.
 * Compatible with Cartesia voice provider only.
 * @see https://docs.vapi.ai/providers/voice/cartesia
 */
export var CartesiaVoicePersona;
(function (CartesiaVoicePersona) {
    CartesiaVoicePersona["CustomerSupportLady"] = "829ccd10-f8b3-43cd-b8a0-4aeaa81f3b30";
    CartesiaVoicePersona["Ariana"] = "ec1e269e-9ca0-402f-8a18-58e0e022355a";
    CartesiaVoicePersona["MidWesternWomen"] = "11af83e2-23eb-452f-956e-7fee218ccb5c";
    CartesiaVoicePersona["Sarah"] = "694f9389-aac1-45b6-b726-9d9369183238";
})(CartesiaVoicePersona || (CartesiaVoicePersona = {}));
export var VoiceCallBackgroundSound;
(function (VoiceCallBackgroundSound) {
    VoiceCallBackgroundSound["Off"] = "off";
    VoiceCallBackgroundSound["Office"] = "office";
})(VoiceCallBackgroundSound || (VoiceCallBackgroundSound = {}));
export var VoiceCallFirstMessageMode;
(function (VoiceCallFirstMessageMode) {
    VoiceCallFirstMessageMode["AssistantSpeaksFirst"] = "assistant-speaks-first";
    VoiceCallFirstMessageMode["AssistantSpeaksFirstWithModelGeneratedMessage"] = "assistant-speaks-first-with-model-generated-message";
    VoiceCallFirstMessageMode["AssistantWaitsForUser"] = "assistant-waits-for-user";
})(VoiceCallFirstMessageMode || (VoiceCallFirstMessageMode = {}));
export var VoiceCallOptionMode;
(function (VoiceCallOptionMode) {
    VoiceCallOptionMode["Enabled"] = "Enabled";
    VoiceCallOptionMode["Disabled"] = "Disabled";
})(VoiceCallOptionMode || (VoiceCallOptionMode = {}));
export var VoiceCallIdleMessage;
(function (VoiceCallIdleMessage) {
    VoiceCallIdleMessage["AreYouStillThere"] = "Are you still there?";
    VoiceCallIdleMessage["IsThereAnythingElseYouNeedHelpWith"] = "Is there anything else you need help with?";
    VoiceCallIdleMessage["FeelFreeToAskMeAnyQuestions"] = "Feel free to ask me any questions.";
    VoiceCallIdleMessage["HowCanIAssistYouFurther"] = "How can I assist you further?";
    VoiceCallIdleMessage["LetMeKnowIfThereIsAnythingYouNeed"] = "Let me know if there's anything you need.";
    VoiceCallIdleMessage["ImStillHereIfYouNeedAssistance"] = "I'm still here if you need assistance.";
    VoiceCallIdleMessage["ImReadyToHelpWheneverYouAre"] = "I'm ready to help whenever you are.";
    VoiceCallIdleMessage["IsThereSomethingSpecificYouAreLookingFor"] = "Is there something specific you're looking for?";
    VoiceCallIdleMessage["ImHereToHelpWithAnyQuestionsYouHave"] = "I'm here to help with any questions you have.";
})(VoiceCallIdleMessage || (VoiceCallIdleMessage = {}));
export const OPENAI_REALTIME_MODELS = [
    VoiceCallModel.gpt_4o_realtime_cluster,
    VoiceCallModel.gpt_4o_realtime_preview,
    VoiceCallModel.gpt_4o_mini_realtime_preview,
];
export const OPENAI_REALTIME_COMPATIBLE_VOICES = [
    ...Object.values(OpenAiStandardVoicePersona),
    ...Object.values(OpenAiRealtimeVoicePersona),
];
export function isRealTimeModel(model) {
    return OPENAI_REALTIME_MODELS.includes(model);
}
export function isElevenLabsCompatibleVoicePersona(persona) {
    return Object.values(ElevenLabsVoicePersona).includes(persona);
}
export function isRealtimeCompatibleVoicePersona(persona) {
    return (Object.values(OpenAiStandardVoicePersona).includes(persona) ||
        Object.values(OpenAiRealtimeVoicePersona).includes(persona));
}
export function isRealTimeExclusiveVoicePersona(persona) {
    return Object.values(OpenAiRealtimeVoicePersona).includes(persona);
}
export function isCartesiaCompatibleVoicePersona(persona) {
    return Object.values(CartesiaVoicePersona).includes(persona);
}
//# sourceMappingURL=voice.js.map